export const sometimes = () => true;
